// extracted by mini-css-extract-plugin
module.exports = {"Main":"accordion-body_Main__M2eqy","Content":"accordion-body_Content__XxB5r"};